<form class="form-horizontal" [formGroup]="registerForm" #formDir="ngForm">

    <!-- Email -->
    <div class="form-group" *ngIf="showEmail" [ngClass]="{'has-danger': invalidEmail || emailDuplicated}">
        <label class="font-l1">Email</label>
        <input class="form-control" type="email" placeholder="correo@ejemplo.com" formControlName="email"
            (input)="onCheckEmail()" (blur)="onCheckEmail()">
        <div class="form-control-feedback" *ngIf="invalidEmail">
            <small *ngIf="email.errors?.email">
                Email inválido
            </small>
            <small *ngIf="email.errors?.required">
                El email es requerido
            </small>
        </div>
        <div *ngIf="!invalidEmail && emailDuplicated" class="form-control-feedback">
            <small>
                El email ya está vinculado a una cuenta
            </small>
        </div>
    </div>

    <!-- Identificación según país -->
    <div class="row" *ngIf="!minimal && showIdCard">
        <div class="form-group col-6" [ngClass]="{'has-danger': invalidIdCardType}">
            <label class="font-l1 pl-1">Tipo de identificación</label>
            <div class="select">
                <select class="form-control" formControlName="idCardType" (change)="onChangeIdCardType()">
                    <option value="0">Seleccioná</option>
                    <ng-container *ngIf="country == 1">
                        <option value="1">Cédula Nacional</option>
                        <option value="2">Residente (DIMEX)</option>
                        <option value="3">Extranjero</option>
                    </ng-container>
                    <ng-container *ngIf="country == 2">
                        <option value="1">Cédula</option>
                        <option value="2">Pasaporte</option>
                        <option value="3">Carné de Residente Permanente</option>
                    </ng-container>
                </select>
            </div>
            <small class="form-control-feedback" *ngIf="invalidIdCardType">
                El tipo de identificación es requerido.
            </small>
        </div>

        <div class="form-group col-6" [ngClass]="{'has-danger': invalidIdCard}">
            <label class="font-l1 pl-1">Identificación</label>
            <input class="form-control" formControlName="idCard" placeholder="Identificación">
            <div class="form-control-feedback" *ngIf="invalidIdCard">
                <small *ngIf="idCard.errors?.required">
                    La identificación es requerida.
                </small>
                <small *ngIf="idCard.errors?.minlength || idCard.errors?.maxlength">
                    Debe tener entre 6 y 15 caracteres.
                </small>
            </div>
        </div>
    </div>

    <!-- Nombre / Apellido -->
    <div class="row" *ngIf="showName">
        <div class="form-group col-6" [ngClass]="{'has-danger': invalidName}">
            <label class="font-l1 pl-1">Nombre</label>
            <input class="form-control" formControlName="name" placeholder="Nombre">
            <small class="form-control-feedback" *ngIf="invalidName">
                El nombre es requerido.
            </small>
        </div>

        <div class="form-group col-6" [ngClass]="{'has-danger': invalidLastName}">
            <label class="font-l1 pl-1">Apellido</label>
            <input class="form-control" formControlName="lastName" placeholder="Apellido">
            <small class="form-control-feedback" *ngIf="invalidLastName">
                El apellido es requerido.
            </small>
        </div>
    </div>

    <!-- Fecha de nacimiento / Género -->
    <div class="row" *ngIf="!minimal">
        <div class="form-group col-6" [ngClass]="{'has-danger': invalidBirthDate}">
            <label class="font-l1 pl-1">Fecha de nacimiento</label>
            <div class="birth-date-field">
                <input class="form-control" formControlName="birthDate" placeholder="11/11/1992"
                    ngbDatepicker #birthPicker="ngbDatepicker" container="body"
                    [minDate]="minBirthDate" [maxDate]="maxBirthDate" [startDate]="startBirthDate"
                    (click)="birthPicker.open()">
                <button class="birth-date-toggle" type="button" tabindex="-1"
                    (click)="birthPicker.toggle()">
                    <i class="mdi mdi-calendar"></i>
                </button>
            </div>
            <div class="form-control-feedback" *ngIf="invalidBirthDate">
                <small *ngIf="birthDate.errors?.required">
                    La fecha de nacimiento es requerida.
                </small>
                <small *ngIf="birthDate.errors?.pattern">
                    Formato inválido (DD/MM/AAAA).
                </small>
            </div>
        </div>

        <div class="form-group col-6" [ngClass]="{'has-danger': invalidGenderType}">
            <label class="font-l1 pl-1">Género</label>
            <div class="select">
                <select class="form-control" formControlName="genderType">
                    <option value="0">Género</option>
                    <option value="1">Masculino</option>
                    <option value="2">Femenino</option>
                    <option value="3">No aplica</option>
                </select>
            </div>
            <small class="form-control-feedback" *ngIf="invalidGenderType">
                El género es requerido.
            </small>
        </div>
    </div>

    <!-- Provincia / Cantón -->
    <div class="row" *ngIf="!minimal">
        <div *ngFor="let field of geoDataStructure" class="form-group col-6"
            [ngClass]="{'has-danger': isInvalidGeo(field.key)}">
            <label class="font-l1 pl-1">{{ field.name | titlecase }}</label>
            <div class="select">
                <select class="form-control" [formControlName]="field.key"
                    (change)="onSelectGeo(field.key, $event.target.value)">
                    <option *ngFor="let option of filteredData[field.key]" [value]="option.id">
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <small class="form-control-feedback" *ngIf="isInvalidGeo(field.key)">
                El campo de {{ field.name | lowercase }} es requerido.
            </small>
        </div>
    </div>

    <!-- Términos y Condiciones -->
    <div class="m-t-20">
        <div class="text-muted font-12">
            Al crear esta cuenta aceptás los
            <a class="text-purple cursor-pointer font-12" href="https://www.somosgivi.com/t%C3%A9rminos-y-condiciones"
                target="_blank">
                Términos y Condiciones
            </a>
            <span class="text-muted font-12"> y las </span>
            <a class="text-purple cursor-pointer font-12" href="https://www.somosgivi.com/deber-de-confidencialidad"
                target="_blank">
                Políticas de Privacidad
            </a>
        </div>
    </div>
</form>
